<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="vision_banner">
      <p>"최고 경쟁력의 Total ICT Solution Company"</p>
    </div>
    <div class="item">
      <div class="tit"><h3>우리의 목표와 지향점</h3></div>
      <ul class="vision_frame">
        <li class="tit">
          <h5>슬로건</h5>
        </li>
        <li class="txt">
          <h6>Challenge 2023!</h6>
        </li>
      </ul>

      <ul class="vision_frame">
        <li class="tit">
          <h5>목표</h5>
        </li>
        <li class="txt">
          <h6>기업 가치 증진</h6>
          <p>
            <span>고객 가치</span> 제공하는 제품과 서비스의 가치와 전문성을
            인정받는 기업
          </p>
          <p>
            <span>내부 가치</span>구성원 개개인의 전문화로 경쟁력이 강한 기업
          </p>
        </li>
      </ul>

      <ul class="vision_frame">
        <li class="tit">
          <h5>전략방향</h5>
        </li>
        <li class="txt">
          <h6>솔루션 경쟁력 강화</h6>
        </li>
      </ul>

      <div class="tit"><h3>DK WAY</h3></div>
      <ul class="vision_frame">
        <li>
          <img :src="require('./../../assets/img/sub/01/0102_01.png')" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "VisionTab.vue",
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/VisionTab.vue